import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AppStateProvider } from './../../services/app-state.provider';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from 'src/app/config/app.constant';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss'],
})
export class CompaniesComponent implements OnInit {
  @ViewChild('contentActivation', { static: false }) content: ElementRef;
  meetingNav: { index: string; name: string; link: string }[];
  activation: boolean;
  token: string;
  url: string;
  teams: any;
  newTeams: any[] = [];
  access_token: any;
  membersList: any;
  memberDetail: any;
  acronym: any;
  myDate;
  total: any;
  contract: any;
  officeToken: any;
  searchText: string = '';
  showLoader = false;
  pageSize: number = 10;
  team: any;
  isVisible: boolean;
  emailShow: boolean;
  emailIdlist: string = '';
  subject: string = '';
  body: string = '';
  showEmail: boolean;
  fromId: any;
  closeResult: string;
  statusText: string;
  selectedTeam: any;
  val: any;
  text: string;
  tempTeams: any;
  newTeamTemp: any;
  filterType: any = "all";
  totalCount: number = 0;
  displayCount;
  checkParkId = environment.nonRfIdParks;
  isRfidEnabled: boolean = false;
  parkId: any;
  public locationId: string;

  constructor(
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    private dataService: DataService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal
  ) { }

  page = 1;

  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'custom-class',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onCancel(module) {
    if (module == 'activation') {
      this.activation = !this.activation;
    } else {
      //this.togglePriviledgeSelection(this.priviledge);
    }
    window.location.reload();
    // this.activation=!this.activation;
  }

  ngOnInit(): void {

    this.parkId = localStorage.getItem('parkId');
    this.locationId = localStorage.getItem('locationId');

    this.isRfidEnabled = this.checkParkId.split(",").includes(this.parkId);

    this.totalCount = 0;
    // localStorage.setItem("displayType","all")

    this.myDate = new Date();
    this.meetingNav = [
      {
        index: '1',
        name: 'Companies',
        link: 'companies/companies-list',
      },
    ];

    const route = {
      index: '1',
      name: 'Companies',
      link: 'companies/companies-list',
    };
    this.appStateSrv.setSideNavState(route);

    this.showLoader = true;

    this.getApiauthorizationToken();
  }

  getApiauthorizationToken() {
    //this.commonService.getApiauthorizationToken().subscribe((res) => {
    this.token =
      'Bearer' + ' ' + localStorage.getItem(AppConstant.localStorage.token);
    if (this.token != null) {
      this.getauthorizationToken();
    }
    //});
  }

  handlePageChange(event) {
    this.page = event;
    this.team = this.teams.list.slice(
      0,
      this.teams.list.length < 10
        ? this.teams.list.length
        : (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  getName(name) {
    if (name)
      return (
        name.split(' ')[0].charAt(0).toUpperCase() +
        ' ' +
        (name.split(' ')[1] !== undefined
          ? name.split(' ')[1].charAt(0).toUpperCase()
          : '')
      );
    else return '';
  }

  openCompanyDetail(team) {
    localStorage.setItem(AppConstant.localStorage.teamId, team.teamId);
    localStorage.setItem(AppConstant.localStorage.tenantId, team.id);
    localStorage.setItem(
      AppConstant.localStorage.companyName,
      team.companyName
    );
    // if (team.isActive) {
    this.router.navigate(['companies/companies-list/company-details']);

    // }
  }
  // toggleActivationSelection(team, show) {
  //   this.activation = !team.isActive;
  //   this.updateTenant(team);
  // }
  getauthorizationToken() {
    this.commonService
      .getauthorizationToken(
        'bearer ' + localStorage.getItem(AppConstant.localStorage.token)
      )
      .subscribe((res) => {
        this.access_token = res.access_token;
        this.officeToken = res.access_token;
        if (this.token != null) {
          this.getAccessPoints();
          this.getTeamsList();
        }
      });
  }

  getAccessPoints() {
    this.url = APIs.getOfficeAccessPoints;
    const header = {
      Authorization: this.token,
    };
    const paramObj = {
      Authorization: this.officeToken,
    };
    this.apiService.get(this.url, paramObj, header).subscribe(
      (response: any) => {
        // this.showLoader = false;
        // this.members=response;
        // let len =this.members.list.length;
      },
      (err) => console.log('error', err)
    );
  }

  updateTenant(team) {
    // console.log('team', team);

    const data = {
      TeamId: this.selectedTeam.teamId,
      isActive: this.activation,
    };
    const header = {
      Authorization: this.token,
    };
    this.apiService.post(APIs.updateTenantStatus, data, '', header).subscribe(
      (result) => {
        this.getCompanyList();
        console.log('result', result);
        this.displayType("all")
      },
      (error) => { }
    );
  }

  getTeamsList() {
    this.url = APIs.getOfficeTeams;
    const header = {
      Authorization: this.token,
    };
    const paramobj = {
      Authorization: this.officeToken,
    };
    this.apiService.get(this.url, paramobj, header).subscribe(
      (response: any) => {
        this.getCompanyList();
        // this.teams=response;
        // this.total=this.teams.length;
        // this.dataService.teams.next(this.teams);
        // this.teams.forEach((data)=>{
        //   // this.getContracts(data._id);
        // })
      },
      (err) => console.log('error', err)
    );
  }

  getCompanyList() {
    this.newTeams = [];
    this.totalCount = 0;
    let locationId = localStorage.getItem("locationId") ?? 1;
    this.url = APIs.getCompanyList + '?locationId=' + locationId;
    const header = {
      Authorization: this.token,
    };

    this.apiService.get(this.url, '', header).subscribe(
      (response: any) => {
        this.showLoader = false;
        this.teams = response;
        this.newTeams = response?.list;
        this.totalCount = response.list.length;
        this.displayCount = Math.ceil(this.totalCount / this.pageSize);
        this.tempTeams = response.list;
        this.newTeamTemp = response.list;
        this.total = this.teams.length;
        this.dataService.teams.next(this.teams);
        this.handlePageChange(1);
      },
      (err) => console.log('error', err)
    );
  }

  searchByText(event: any) {
    console.log(event);
    console.log(this.newTeams);
    this.newTeams = this.teams.list.filter((item: { companyName: any }) => {
      return item.companyName.toLowerCase().includes(event.toLowerCase());
    });
    this.totalCount = this.newTeams?.length;
    console.log(this.newTeams);
    if (event == '') {
      console.log("HERE");
      this.newTeams = this.newTeamTemp;
      // this.totalCount = this.newTeamTemp?.length;
      console.log(this.newTeams);
    }
  }

  displayType(event: any) {

    console.log(event);
    this.val = event;

    if (this.val == 'active') {
      this.text = "Active";
      this.filterType = "active";
      this.newTeams = this.tempTeams.filter((data: any) => data.isActive == true);
    } else if (this.val == 'inactive') {
      this.text = "Inactive";
      this.filterType = "inactive";
      this.newTeams = this.tempTeams.filter((data: any) => data.isActive == false);
    } else {
      this.filterType = "all";
      this.text = " ";
      this.newTeams = [...this.tempTeams];
    }

    this.teams.list = [...this.newTeams];
    this.totalCount = this.newTeams.length;
    this.displayCount = Math.ceil(this.totalCount / this.pageSize);
    this.page = 1;
  }

  getContracts(teamId) {
    this.url = APIs.getOfficeContracts;
    const paramobj = {
      team: teamId,
      Authorization: this.token,
    };
    const header = {
      Authorization: this.token,
    };
    this.apiService.get(this.url, paramobj, header).subscribe(
      (response: any) => {
        this.contract = response;
        // this.dataService.memberships.next(this.membersList);
      },
      (err) => console.log('error', err)
    );
  }

  emailClick(member) {
    console.log(member);
    console.log(member.id);
    this.emailIdlist = '';
    this.emailIdlist = member.adminEmailId;
    this.emailShow = true;
    localStorage.setItem(AppConstant.localStorage.emailId, this.emailIdlist);
    this.getEmail(member.id);
    this.router.navigate(['companies/companies-list/email']);
  }

  feedbackClick(member) {
    console.log(member);
    console.log(member.id);
    this.emailIdlist = '';
    this.subject = '';
    this.body = '';
    this.emailIdlist = member.adminEmailId;
    this.emailShow = true;
    localStorage.setItem(AppConstant.localStorage.emailId, this.emailIdlist);
    this.getEmail(member.id);
    this.getOffBoardingTenantEmail(member.id);
  }
  getOffBoardingTenantEmail(id) {
    console.log(id);
    this.url = APIs.getOffBoardingEmail;
    const paramobj = {
      tenantId: id,
      Authorization: this.token,
    };
    const header = {
      Authorization: this.token,
    };
    this.apiService.get(this.url, paramobj, header).subscribe((res) => {
      console.log(res);
      this.subject = res.response.subject;
      this.body = res.response.body;
      console.log('sub', this.subject);
      console.log('body', this.body);
      localStorage.setItem(AppConstant.localStorage.subject, this.subject);
      localStorage.setItem(AppConstant.localStorage.body, this.body);
      this.router.navigate(['companies/companies-list/feedback']);
    });
  }
  getEmail(id) {
    console.log(id);
    this.url = APIs.getAdmin;
    this.apiService.get(this.url, { id: btoa(id) }).subscribe((response) => {
      console.log(response);
      this.fromId = response.data.adminEmailId;
      console.log(this.fromId);
      localStorage.setItem(AppConstant.localStorage.fromId, this.fromId);
    });
  }

  toggleActivationSelection(team, show) {
    console.log('team', team);
    this.selectedTeam = team;
    this.activation = !team.isActive;
    // this.updateTenant(team);
    this.statusText = this.activation ? 'Activate' : 'Deactivate';
    // if (!this.activation) {
    this.open(this.content);
    // }
  }

  updateTenantStatus(team) {
    this.updateTenant(team);
    // this.open(this.content);
  }

  rfidBulkUpload() {
    this.router.navigateByUrl('companies/companies-list/rfid-bulk-upload');
  }
}
